
// const API_URL = 'http://127.0.0.1/'
 const API_URL = 'https://e20.remodigital.in/'
// const API_URL = 'https://amsaaluat.remodigital.in/' 
 const CLIENT_URL = 'https://www.uat.e20.ae/'
// const CLIENT_URL = 'http://localhost:3001/'
//const CLIENT_URL = 'https://thankful-pebble-07ab4240f.3.azurestaticapps.net'

export {API_URL,CLIENT_URL}
